import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { Dispatch } from "react";
import {
  Control,
  UseFormGetValues,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { IFilter } from ".";
import APIS from "../../constant/Endpoint";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import DateRangePicker from "../Reusable/DateRangePicker";

interface Props {
  setValue: UseFormSetValue<IFilter>;
  getValues: UseFormGetValues<IFilter>;
  control: Control<IFilter, any>;
  setDate: Dispatch<any>;
  adminOnly: boolean;
  watch: UseFormWatch<IFilter>;
  handleReset: () => void;
}

const Filter = ({
  setValue,
  getValues,
  setDate,
  control,
  watch,
  adminOnly,
  handleReset,
}: Props) => {
  const pickupBranch = watch("pickup_branch");
  return (
    <AccessControl
      allowedPermissions={["can_edit_overview_filter"]}
      renderNoAccess={
        <>
          <ComboboxFilter<IFilter>
            url={APIS.BRANCH}
            queryKey={"branch"}
            name={"pickup_branch"}
            control={control}
            label={"From Branch"}
            params={{
              is_active: true,
            }}
            placeholder={"Select Branch"}
            disabled={true}
          />
          <ComboboxFilter<IFilter>
            url={APIS.BRANCH}
            queryKey={"branch"}
            name={"to_branch"}
            control={control}
            disabled={true}
            label={"To Branch"}
            params={{
              is_active: true,
            }}
            placeholder={"Select Branch"}
          />
          <ComboboxFilter<IFilter>
            url={APIS.STAFF}
            queryKey={"staff"}
            params={{ is_staff: true, is_active: true }}
            name={"staff"}
            control={control}
            label={"Staff"}
            disabled={true}
            placeholder={"Select Staff"}
          />
          <ComboboxFilter<IFilter>
            url={APIS.MERCHANT}
            queryKey={"merchant"}
            name={"vendor"}
            control={control}
            label={"Merchant"}
            disabled={true}
            params={{
              is_active: true,
            }}
            placeholder={"Select Merchant"}
          />
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"date_range"}
            disabled={true}
            getValues={getValues}
            setDate={setDate}
          />
        </>
      }
    >
      <>
        <ComboboxFilter<IFilter>
          url={`${APIS.BRANCH}allowed/`}
          queryKey={"branch"}
          name={"pickup_branch"}
          control={control}
          label={"From Branch"}
          params={{ is_active: true }}
          placeholder={"Select Branch"}
          // disabled={adminOnly}
        />
        <ComboboxFilter<IFilter>
          key={pickupBranch ? "branch" : "allowed-branch"}
          url={pickupBranch ? APIS.BRANCH : `${APIS.BRANCH}allowed/`}
          queryKey={"destination"}
          name={"to_branch"}
          control={control}
          label={"To Branch"}
          params={{ is_active: true }}
          placeholder={"Select Branch"}
        />
        <ComboboxFilter<IFilter>
          url={APIS.STAFF}
          queryKey={"staff"}
          params={{ is_staff: true, is_active: true }}
          name={"staff"}
          control={control}
          label={"Staff"}
          placeholder={"Select Staff"}
        />
        <ComboboxFilter<IFilter>
          url={APIS.MERCHANT}
          queryKey={"merchant"}
          name={"vendor"}
          control={control}
          label={"Merchant"}
          params={{
            is_active: true,
          }}
          placeholder={"Select Merchant"}
        />
        <DateRangePicker
          label={"Select Date Range"}
          setValue={setValue}
          name={"date_range"}
          getValues={getValues}
          setDate={setDate}
        />
        <button
          className={tw`absolute -top-4  right-2 focus:outline-none`}
          onClick={() => handleReset()}
        >
          Reset
        </button>
      </>
    </AccessControl>
  );
};

export default Filter;
